import type { RfqType } from '@convex/constants/types.lib'

export interface RfqTypeConfig {
  key: RfqType
  label: string
  description: string
  icon: 'ShoppingCart' | 'Tag' | 'Recycle'
  showBudget: boolean
  showAskingPrice: boolean
  showHazmat: boolean
  showSpecs: boolean
  showAttachments: boolean
  allowMultipleLocations: boolean
  requiresInventoryDetails: boolean
}

export const RFQ_TYPE_CONFIGS: Record<RfqType, RfqTypeConfig> = {
  buy: {
    key: 'buy',
    label: 'Buy',
    description: 'Request quotes from suppliers',
    icon: 'ShoppingCart',
    showBudget: true,
    showAskingPrice: false,
    showHazmat: false,
    showSpecs: true,
    showAttachments: true,
    allowMultipleLocations: true,
    requiresInventoryDetails: false,
  },
  sell: {
    key: 'sell',
    label: 'Sell',
    description: 'Get offers for your inventory',
    icon: 'Tag',
    showBudget: false,
    showAskingPrice: true,
    showHazmat: false,
    showSpecs: true,
    showAttachments: true,
    allowMultipleLocations: true,
    requiresInventoryDetails: true,
  },
  recycle: {
    key: 'recycle',
    label: 'Recycle',
    description: 'Find recycling partners',
    icon: 'Recycle',
    showBudget: false,
    showAskingPrice: false,
    showHazmat: true,
    showSpecs: true,
    showAttachments: true,
    allowMultipleLocations: false,
    requiresInventoryDetails: true,
  },
} as const

export type FormMode = 'anonymous' | 'authenticated'

export interface RfqFormModeConfig {
  requireContact: boolean
  prefillContact: boolean
  showConsent: boolean
  canSaveDraft: boolean
  requireDimensions: boolean
  enforcePhotoRequirement: boolean
  submitLabel: string
  successRedirect: 'thank-you' | 'dashboard'
}

export const FORM_MODE_CONFIGS: Record<FormMode, RfqFormModeConfig> = {
  anonymous: {
    requireContact: true,
    prefillContact: false,
    showConsent: true,
    canSaveDraft: false,
    requireDimensions: false,
    enforcePhotoRequirement: false,
    submitLabel: 'Get Free Quotes',
    successRedirect: 'thank-you',
  },
  authenticated: {
    requireContact: false,
    prefillContact: true,
    showConsent: false,
    canSaveDraft: true,
    requireDimensions: true,
    enforcePhotoRequirement: true,
    submitLabel: 'Submit Request',
    successRedirect: 'dashboard',
  },
} as const

export function getTypeConfig(rfqType: RfqType): RfqTypeConfig {
  return RFQ_TYPE_CONFIGS[rfqType]
}

export function getModeConfig(mode: FormMode): RfqFormModeConfig {
  return FORM_MODE_CONFIGS[mode]
}
